<template>
  <div class="perfil-page">
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="perfil-shell">
      <!-- Header -->
      <header class="page-header fade-in">
        <div>
          <h1 class="page-title">Hola, {{ nombreUsuario }}</h1>
          <p class="page-sub">Resumen de tu actividad en el sistema</p>
        </div>
        <button class="btn-primary" @click="cambiarPassword">
          <v-icon size="15" class="mr-2">mdi-lock-reset</v-icon>
          Cambiar contraseña
        </button>
      </header>

      <!-- Pagos -->
      <section class="dash-section fade-in delay-100">
        <div class="section-eyebrow">
          <span class="tick-mark"></span>
          Estadísticas de pagos
        </div>

        <div class="stats-grid">
          <div v-for="(carta, index) in datosPagos" :key="'pago-' + index" class="stat-card"
            :style="{ animationDelay: (0.05 * index) + 's' }">
            <div class="stat-top">
              <div class="stat-icon stat-icon-accent">
                <v-icon size="18" color="#0E0E10">{{ carta.icono }}</v-icon>
              </div>
            </div>
            <div class="stat-value">{{ carta.total }}</div>
            <div class="stat-label">{{ carta.nombre }}</div>
          </div>
        </div>
      </section>

      <!-- Visitas -->
      <section class="dash-section fade-in delay-200">
        <div class="section-eyebrow">
          <span class="tick-mark"></span>
          Estadísticas de visitas
        </div>

        <div class="stats-grid">
          <div v-for="(carta, index) in datosVisitas" :key="'visita-' + index" class="stat-card"
            :style="{ animationDelay: (0.05 * index) + 's' }">
            <div class="stat-top">
              <div class="stat-icon">
                <v-icon size="18" color="#F2F2ED">{{ carta.icono }}</v-icon>
              </div>
            </div>
            <div class="stat-value">{{ carta.total }}</div>
            <div class="stat-label">{{ carta.nombre }}</div>
          </div>
        </div>
      </section>

      <!-- Acciones rápidas -->
      <section class="dash-section fade-in delay-300">
        <div class="card-flat">
          <div class="card-flat-head">
            <span class="section-eyebrow">
              <span class="tick-mark"></span>
              Acciones rápidas
            </span>
          </div>
          <div class="card-flat-body">
            <div class="quick-actions-grid">
              <button class="quick-action-btn" @click="$router.push('/dashboard')">
                <div class="quick-action-icon">
                  <v-icon size="20" color="#F2F2ED">mdi-view-dashboard</v-icon>
                </div>
                <span>Dashboard</span>
              </button>
              <button class="quick-action-btn" @click="$router.push('/registrar-visita')">
                <div class="quick-action-icon">
                  <v-icon size="20" color="#F2F2ED">mdi-calendar-plus</v-icon>
                </div>
                <span>Registrar visita</span>
              </button>
              <button class="quick-action-btn" @click="$router.push('/productos')">
                <div class="quick-action-icon">
                  <v-icon size="20" color="#F2F2ED">mdi-cart</v-icon>
                </div>
                <span>Productos</span>
              </button>
              <button class="quick-action-btn" @click="cambiarPassword">
                <div class="quick-action-icon">
                  <v-icon size="20" color="#F2F2ED">mdi-lock-reset</v-icon>
                </div>
                <span>Cambiar contraseña</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Loading Overlay -->
    <div v-if="cargando" class="loading-overlay">
      <div class="loading-inner">
        <div class="spinner"></div>
        <p class="loading-text">Cargando información…</p>
      </div>
    </div>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import CartasPersonalizadas from '../Dialogos/CartasPersonalizadas.vue'
import SelectorTema from "@/components/SelectorTema.vue";

export default {
  name: "MiPerfil",
  components: { CartasPersonalizadas, SelectorTema },

  data: () => ({
    cargando: false,
    nombreUsuario: localStorage.getItem('usuario') || 'Usuario',
    datosVisitas: [],
    datosPagos: [],
  }),

  mounted() {
    this.obtenerInformacion()
  },

  methods: {
    cambiarPassword() {
      this.$router.push({ name: 'CambiarPassword' })
    },

    async obtenerInformacion() {
      this.cargando = true;

      try {
        const resultado = await HttpService.obtenerConDatos({
          metodo: 'informacion_perfil',
          idUsuario: localStorage.getItem('idUsuario')
        }, 'usuarios.php');

        this.crearCartas(resultado.datosVisitas, resultado.datosPagos);
      } catch (error) {
        console.error('Error obteniendo información del perfil:', error);
        this.$store.commit('mostrarMensaje', {
          texto: '❌ Error al cargar la información del perfil',
          color: 'error'
        });
      } finally {
        this.cargando = false;
      }
    },

    crearCartas(visitas, pagos) {
      this.datosVisitas = [
        {
          icono: 'mdi-calendar-star',
          nombre: 'Total visitas',
          total: visitas.totalVisitas || 0
        },
        {
          icono: 'mdi-calendar',
          nombre: 'Visitas hoy',
          total: visitas.visitasHoy || 0
        },
        {
          icono: 'mdi-calendar-range',
          nombre: 'Visitas semana',
          total: visitas.visitasSemana || 0
        },
        {
          icono: 'mdi-calendar-month',
          nombre: 'Visitas mes',
          total: visitas.visitasMes || 0
        },
      ];

      this.datosPagos = [
        {
          icono: 'mdi-currency-usd',
          nombre: 'Total pagos',
          total: '$' + (pagos.totalPagos || '0.00')
        },
        {
          icono: 'mdi-calendar',
          nombre: 'Pagos hoy',
          total: '$' + (pagos.pagosHoy || '0.00')
        },
        {
          icono: 'mdi-calendar-range',
          nombre: 'Pagos semana',
          total: '$' + (pagos.pagosSemana || '0.00')
        },
        {
          icono: 'mdi-calendar-month',
          nombre: 'Pagos mes',
          total: '$' + (pagos.pagosMes || '0.00')
        },
      ];
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.perfil-page {
  --bg: #0E0E10;
  --card: #17171A;
  --card-hover: #1B1B1F;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
}

.perfil-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  padding: 40px;
}

.bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(242, 242, 237, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(242, 242, 237, 0.02) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.perfil-shell {
  position: relative;
  z-index: 1;
  max-width: 1120px;
  margin: 0 auto;
}

/* ===== HEADER ===== */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 22px 26px;
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  margin-bottom: 28px;
}

.page-title {
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 4px;
}

.page-sub {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* ===== SECTIONS ===== */
.dash-section {
  margin-bottom: 28px;
}

.section-eyebrow {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

.tick-mark {
  width: 12px;
  height: 1px;
  background: var(--accent);
}

/* ===== STATS ===== */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
}

.stat-card {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 18px;
  animation: fadeInUp 0.4s ease both;
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.stat-card:hover {
  border-color: var(--text-tertiary);
  transform: translateY(-2px);
}

.stat-top {
  margin-bottom: 14px;
}

.stat-icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon-accent {
  background: var(--accent);
  border-color: var(--accent);
}

.stat-value {
  font-family: var(--font-display);
  font-size: 24px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12.5px;
  color: var(--text-secondary);
}

/* ===== CARD / ACCIONES ===== */
.card-flat {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.card-flat-head {
  padding: 18px 24px;
  border-bottom: 1px solid var(--card-border);
}

.card-flat-head .section-eyebrow {
  margin-bottom: 0;
}

.card-flat-body {
  padding: 24px;
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.quick-action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 22px 16px;
  background: transparent;
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  color: var(--text-primary);
}

.quick-action-btn:hover {
  border-color: var(--text-tertiary);
  background: rgba(255, 255, 255, 0.03);
}

.quick-action-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.quick-action-btn span {
  font-size: 12.5px;
  font-weight: 500;
  text-align: center;
}

/* ===== BUTTONS ===== */
.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover {
  filter: brightness(1.08);
}

/* ===== LOADING ===== */
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(14, 14, 16, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid var(--card-border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.loading-text {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-secondary);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.4s ease both;
}

.delay-100 { animation-delay: 0.05s; }
.delay-200 { animation-delay: 0.1s; }
.delay-300 { animation-delay: 0.15s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in, .stat-card, .spinner { animation: none; }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .perfil-page {
    padding: 20px;
  }

  .page-header {
    padding: 18px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .quick-actions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/MiPerfil.vue